import {
  WorkflowExecutionCancelationReason,
  WorkflowExecutionThreadStatus,
} from 'src/interfaces/workflows.interface';

export enum HumanDetectionResult {
  HUMAN = 'human',
  NO_HUMAN = 'no_human',
}

export type Call = {
  id: string;
  status: string;
  error_message: string | null;
  recording_available: boolean;
  transcript: string;
  human_detection_result?: HumanDetectionResult;
  do_not_call_result: boolean;
  telephony_id: string | null;
  stage: string;
  stage_outcome: string;
  telephony_metadata: TelephonyMetadata | null;
  start_time: number;
  end_time: number;
  to_number: string;
  from_number: string;
  agent: { id: string; name: string } | string;
  telephony_provider: string;
  agent_phone_number: string;
  hipaa_compliant: boolean;
  on_no_human_answer: string;
  context: Record<string, unknown>;
  run_do_not_call_detection: boolean;
  telephony_account_connection: string | null;
  telephony_params: Record<string, unknown>;
  is_outgoing: boolean;
  post_call_results: PostCallResults;
  errors: string[];
};

export type PostCallResults = {
  content: string;
  tokenUsage: object;
};

type TelephonyMetadata = {
  call_sid: string;
  account_sid: string;
};

export type CallPayload = {
  id: string;
  agent: string;
  event: string;
  error_message: string;
  recording_available: boolean;
  start_time: string;
  end_time: string;
  from_number: string;
  to_number: string;
  status: string;
};

export type ComparisonFilter = {
  comparison: string;
  value: string | string[];
};

export type BetweenFilter = {
  comparison: string;
  value: [string, string];
};

export type CallFilters = {
  agent?: string;
  status?: string;
  contact_number?: string;
  from_number?: string;
  to_number?: string;
  start_time?: BetweenFilter | null;
  call_id?: string;
  end_time?: ComparisonFilter | null;
  is_voicemail?: boolean;
  duration?: { comparison: string; value: number };
  successful_actions?: Array<{ type: string; label: string }>;
  transcript_keyword?: string;
};

export type ScheduledCallAgent = {
  id: string;
  name?: string;
};

export type ScheduledCall = {
  id: string;
  created_at: string;
  execution_id: string;
  agent: ScheduledCallAgent;
  from_number: string;
  to_number: string;
  linked_call_id?: string;
  call_id?: string;
  resume_at: string | null;
  status: WorkflowExecutionThreadStatus;
  cancelation_reason?: WorkflowExecutionCancelationReason;
};

export type ScheduledCallFilters = {
  agent?: string;
  contact_number?: string;
  from_number?: string;
  to_number?: string;
  statuses?: WorkflowExecutionThreadStatus[];
  created_at?: BetweenFilter;
};
